// Copyright (c) 2017 Deere & Company

export const getDecodedLayouts = encodedLayouts =>
    encodedLayouts.map(layout => ({
        ...layout,
        columnState: JSON.parse(atob(layout.columnState)),
        filterModel: JSON.parse(atob(layout.filterModel)),
        sortModel: JSON.parse(atob(layout.sortModel))

    }));

export const stripInvalidLayouts = layouts =>
    layouts.filter(layout => (
        layout.columnState && layout.filterModel && layout.sortModel
    ));



// WEBPACK FOOTER //
// ./src/shared/services/get-decoded-layouts.js